import { FC, useMemo } from 'react';
import { FormTextEditor } from '../../../form';
import { Box, IconButton, styled } from '@mui/material';
import { fontHelper } from '../../../../helpers/font/font.helper';
import { UnpinGreyIcon } from '../../../../../svg/custom.svg';
import { orderDetailsState } from '../../../../../pages/order/edit/states/orderDetails/orderDetails.state';

export const NotePinned: FC<INotePinned> = ({ isNotePinned }) => {
  const defaultFontSize = useMemo(() => fontHelper.getDefaultFont(['fontSize']), []);

  const handleUnpinClick = () => {
    orderDetailsState.pub.updateIsNotePinned(false);
  };

  return (
    <>
      {isNotePinned && (
        <SBox width='300px'>
          <SUnpinButton onClick={handleUnpinClick} size='small'>
            <UnpinGreyIcon />
          </SUnpinButton>
          <FormTextEditor
            name='note'
            defaultFormat={defaultFontSize}
            minHeight={106}
            disabled={true}
          />
        </SBox>
      )}
    </>
  );
};

const SBox = styled(Box)({
  position: 'relative',
  ' & .remirror-theme .remirror-editor-wrapper': {
    padding: '0px',
    '& div': {
      maxHeight: '106px',
      overflowX: 'hidden',
      paddingRight: '25px',
      '& p': {
        whiteSpace: 'pre-wrap',
      },
    },

    '& div:hover': {
      boxShadow: '0px 0px 0px 0.06em #bdbdbd',
    },
  },
});

const SUnpinButton = styled(IconButton)({
  position: 'absolute',
  top: 5,
  right: 5,
  zIndex: 10,
  '& svg': {
    width: 19,
    height: 22,
  },
});

interface INotePinned {
  isNotePinned?: boolean;
}
